import { render, staticRenderFns } from "./chatBox.vue?vue&type=template&id=70263627&scoped=true&"
import script from "./chatBox.vue?vue&type=script&lang=js&"
export * from "./chatBox.vue?vue&type=script&lang=js&"
import style0 from "./chatBox.vue?vue&type=style&index=0&id=70263627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70263627",
  null
  
)

export default component.exports